import { analyticsService } from "@services/analyticsService";
import pick from "lodash/pick";
import { WSNotificationResponse } from "../components/Notifications";

export const useTrackClickNotification = (personId: string) => {
  return (notification: WSNotificationResponse) => {
    analyticsService.track("Notification Clicked", {
      personId,
      ...pick(
        notification,
        "id",
        "type",
        "context",
        "priority",
        "handle",
        "subject"
      )
    });
  };
};
